document.addEventListener( 'DOMContentLoaded', function () {
	const banner = document.getElementById( 'app-banner' );
	const closeBtn = document.getElementById( 'close-banner' );
	const appLink = document.getElementById( 'app-link' );
	const subtitleEl = document.getElementById( 'app-banner-subtitle' );

	if ( ! banner ) return;

	const ua = navigator.userAgent || navigator.vendor || window.opera;

	// --- OS detection ---
	const isAndroid = /android/i.test( ua );
	const isiOS = /iPhone|iPad|iPod/i.test( ua );

	// --- Browser detection ---
	const isChrome = /chrome|crios/i.test( ua );
	const isEdge = /edg|edgios/i.test( ua );
	const isFirefox = /firefox|fxios/i.test( ua );
	const isSafari = /^((?!chrome|crios|edg|edgios|fxios).)*safari/i.test( ua );

	// --- Show only on Android/iOS Chrome, Edge, Firefox ---
	const shouldShow = ( isAndroid || isiOS ) && ( isChrome || isEdge || isFirefox ) && ! isSafari;

	// --- Hide permanently if dismissed ---
	if ( localStorage.getItem( 'appBannerDismissed' ) === 'true' ) return;

	// --- Only display if device & browser match ---
	if ( shouldShow ) {
		banner.classList.add( 'visible' );

		// --- ANDROID ---
		if ( isAndroid ) {
			subtitleEl.innerHTML =
				'Your official home for all things URC!<br>FREE – On Google Play';

			if ( localStorage.getItem( 'urcAppInstalled' ) === 'true' ) {
				appLink.textContent = 'OPEN';
				appLink.href = 'urc://';
			} else {
				appLink.textContent = 'INSTALL';
				appLink.href = 'https://play.google.com/store/apps/details?id=org.pro14rugby.app';
			}

			appLink.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				let now = Date.now();
				window.location.href = 'urc://';
				setTimeout( () => {
					if ( Date.now() - now < 1500 ) {
						window.location.href =
							'https://play.google.com/store/apps/details?id=org.pro14rugby.app';
					} else {
						appLink.textContent = 'OPEN';
						appLink.href = 'urc://';
						localStorage.setItem( 'urcAppInstalled', 'true' );
					}
				}, 1000 );
			} );
		}

		// --- iOS Chrome, Edge, Firefox ---
		else if ( isiOS && ( isChrome || isEdge || isFirefox ) ) {
			subtitleEl.innerHTML = 'Your official home for all things URC!<br>FREE – On App Store';
			appLink.textContent = 'VIEW';

			appLink.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				let now = Date.now();
				window.location.href = 'urc://';
				setTimeout( () => {
					if ( Date.now() - now < 1500 ) {
						window.location.href =
							'https://apps.apple.com/in/app/united-rugby-championship/id1436694463';
					}
				}, 1000 );
			} );
		}
	}

	// --- Close button ---
	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', () => {
			banner.classList.remove( 'visible' );
			localStorage.setItem( 'appBannerDismissed', 'true' );
		} );
	}
} );
